import { FC, useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import Step from "./Step";
import StepFive from "../StepPages/StepFive/StepFive";
import { ObjectsRegister } from "../StepPages/StepTwo/ObjectsRegister/ObjectsRegister";
import StepOne from "pages/StepPages/StepOne";
import StepFour from "pages/StepPages/StepFour";
import cn from "classnames";
import styles from "./CategorizationPage.module.sass";
import { ObjectList } from "pages/StepPages/StepThree/ObjectList/ObjectList";
import { StepSeven } from "pages/StepPages/StepSeven/StepSeven";
import { StepSix } from "pages/StepPages/StepSix/StepSix";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { getCommission } from "toolkit/steps/stepOne/stepOne.thunks";
import { StepTwo } from "pages/StepPages/StepTwo/BusinessProcesses/StepTwo";
import { clearCommission } from "toolkit/steps/stepOne/stepOne.slice";
import { userAPI } from "libs/apiClient/User";
import { statusesAPI } from "libs/apiClient/Statuses";
import { commissionsAPI } from "libs/apiClient/Commissions";
import { snackWrapper } from "helpers";
import {getSelectedOrganization} from "toolkit/organizations/organizations.thunks";

const dependencies = [
	"categorization.commission.read",
	"categorization.business_process_registry.read",
	"categorization.object_registry.read",
	"categorization.object_list.read",
	"categorization.threat_model.read",
	"categorization.step_5.read",
	"categorization.step_6.read",
	"categorization.step_7.read",
];

const CategorizationPage: FC = () => {
	const dispatch = useAppDispatch();

	const params = useParams();
	const { organizationId, stepId } = params
	const currentCommission = useAppSelector((state) => state.stepOne.currentCommission);
	const currentOrgs = useAppSelector((state) => state.organizations.selectedOrganization);

	const location: any = useLocation();

	const url = `/categorization/organizations/${organizationId}/steps/`;

	const [dataSteps, setDataSteps] = useState<any>();

	const [stepAccept, setStepAccept] = useState({
		"categorization.commission.read": false,
		"categorization.business_process_registry.read": false,
		"categorization.object_registry.read": false,
		"categorization.object_list.read": false,
		"categorization.threat_model.read": false,
		"categorization.step_5.read": false,
		"categorization.step_6.read": false,
		"categorization.step_7.read": false,
	});

	useEffect(() => {
		userAPI.permissionsCheckCreate(Number(organizationId), dependencies).then((r) => {
			if (r && r.data.length) {
				setStepAccept((prevState) => {
					const newState = { ...prevState };
					r.data.forEach((_: string) => {
						const key = _ as keyof typeof newState;
						newState[key] = true;
					});
					return newState;
				});
			}
		});
		//eslint-disable-next-line
	}, []);

	const steps: Record<string, JSX.Element> = {
		"1.1": <StepOne />,
		"2.1": <StepTwo />,
		"2.2": <ObjectsRegister />,
		"3.1": <ObjectList />,
		"4.1": <StepFour.One />,
		"4.2": <StepFour.Two />,
		"5.1": <StepFive />,
		"6.1": <StepSix />,
		"7.1": <StepSeven />,
	};

	useEffect(() => {
		if (location.pathname === `/categorization/organizations/${organizationId}/steps`) {
			statusesAPI.stepsList({ org_id: Number(organizationId) }).then((data) => {
				setDataSteps(data.data);
			});
		}
		//eslint-disable-next-line
	}, [location.pathname]);

	useEffect(() => {
		if (
			/^\/categorization\/organizations\/\d+\/steps$/.test(location.pathname) &&
			stepAccept["categorization.commission.read"]
		) {
			commissionsAPI
				.orgcomsList()
				.then((res) => {
					return res.data.find((item: any) => item.id === Number(organizationId));
				})
				.then((result) => {
					if (result && result.commissionTempId) {
						dispatch(getCommission(result.commissionTempId));
					} else {
						dispatch(clearCommission());
					}
				});
		}
		//eslint-disable-next-line
	}, [stepAccept["categorization.commission.read"]]);

	useEffect(() => {
		if (organizationId) {
			dispatch(getSelectedOrganization(+organizationId))
		}
		//eslint-disable-next-line
	},[organizationId]);

	const needRules = () => {
		snackWrapper("error", "У вас недостаточно прав");
	};
	// eslint-disable-next-line no-lone-blocks
	{
		return currentOrgs ? (
			stepId ? (
				steps[stepId]
			) : (
				<div className={styles.page}>
					<h1 className={styles.pageTitle}>
						<div className={styles.info}>Категорирование для</div>
						<div>{currentOrgs?.fullName}</div>
					</h1>
					{currentOrgs?.categorizable && !currentOrgs.archived ? (
						<div className={styles.steps}>
							<Step
								accept={stepAccept["categorization.commission.read"] ?? currentOrgs?.categorizable}
								stepNumber={1}
								status={dataSteps?.commission?.status}>
								{stepAccept["categorization.commission.read"] ?? currentOrgs?.categorizable ? (
									<Link
										to={
											//@ts-ignore
											currentCommission &&
											//@ts-ignore
											currentCommission.listOfCommissionMembers.length
												? //@ts-ignore
												  `/commission/${organizationId}/${currentCommission.listOfCommissionMembers[0]?.commissionId}`
												: url + "1.1"
										}
										className={cn(styles.active)}>
										1.1 Создание комиссии по категорированию ОКИИ
									</Link>
								) : (
									<span className={styles.active} onClick={() => currentOrgs?.categorizable && needRules()}>
										1.1 Создание комиссии по категорированию ОКИИ
									</span>
								)}
								<div className={styles.info}>
									<div className={styles.subTitle}>Статус комиссии</div>
									<div className={styles.subText}>{dataSteps?.commission?.commissionStatus || "Не утвержден"}</div>
								</div>
							</Step>

							<Step
								accept={
									(stepAccept["categorization.business_process_registry.read"] ||
										stepAccept["categorization.object_registry.read"]) ??
									currentOrgs?.categorizable
								}
								stepNumber={2}
								status={dataSteps?.process?.status}>
								{stepAccept["categorization.business_process_registry.read"] ?? currentOrgs?.categorizable ? (
									<Link to={url + "2.1"} className={cn(styles.active)}>
										2.1 Актуализация реестра бизнес-процессов
									</Link>
								) : (
									<span className={styles.active} onClick={() => currentOrgs?.categorizable && needRules()}>
										2.1 Актуализация реестра бизнес-процессов
									</span>
								)}
								<div className={styles.info}>
									<div className={styles.subTitle}>Кол-во бизнес процессов</div>
									<div className={styles.subText}>
										<span className={styles.crit}>крит. БП {dataSteps?.process?.critProcessesCount}</span>
										<span> / {dataSteps?.process?.processesCount} БП</span>
									</div>
								</div>

								<div className={styles.line} />
								{stepAccept["categorization.object_registry.read"] ?? currentOrgs?.categorizable ? (
									<Link to={url + "2.2"} className={cn(styles.active)}>
										2.2 Создание реестра объектов
									</Link>
								) : (
									<span className={styles.active} onClick={() => currentOrgs?.categorizable && needRules()}>
										2.2 Создание реестра объектов
									</span>
								)}

								<div className={styles.info}>
									<div className={styles.subTitle}>Объектов добавлено</div>
									<div className={styles.subText}>{dataSteps?.process?.objectsCount}</div>
								</div>
							</Step>

							<Step
								accept={stepAccept["categorization.object_list.read"] ?? currentOrgs?.categorizable}
								stepNumber={3}
								status={dataSteps?.okii?.status}>
								{stepAccept["categorization.object_list.read"] ?? currentOrgs?.categorizable ? (
									<Link to={url + "3.1"} className={cn(styles.active)}>
										3.1 Формирование перечня объектов критической информационной инфраструктуры
									</Link>
								) : (
									<span className={styles.active} onClick={() => currentOrgs?.categorizable && needRules()}>
										3.1 Формирование перечня объектов критической информационной инфраструктуры
									</span>
								)}

								<div className={styles.info}>
									<div className={styles.subTitle}>Статус перечня</div>
									<div className={styles.subText}>{dataSteps?.okii?.enumStatus || "Не сформирован"}</div>
								</div>
								<div className={styles.info}>
									<div className={styles.subTitle}>Дополнений</div>
									<div className={styles.subText}>{dataSteps?.okii?.additionsCount}</div>
								</div>
								<div className={styles.info}>
									<div className={styles.subTitle}>Объектов</div>
									<div className={styles.subText}>{dataSteps?.okii?.objectsCount}</div>
								</div>
							</Step>

							<Step
								accept={stepAccept["categorization.threat_model.read"] ?? currentOrgs?.categorizable}
								stepNumber={4}
								status={dataSteps?.threat?.status}>
								{stepAccept["categorization.threat_model.read"] ?? currentOrgs?.categorizable ? (
									<Link to={url + "4.1"} className={cn(styles.active)}>
										4.1 Формирование модели угроз
									</Link>
								) : (
									<span className={styles.active} onClick={() => currentOrgs?.categorizable && needRules()}>
										4.1 Формирование модели угроз
									</span>
								)}
								<div className={styles.info}>
									<div className={styles.subTitle}>Сформировано моделей угроз</div>
									<div className={styles.subText}>{dataSteps?.threat?.threatsCount}</div>
								</div>
								<div className={styles.line} />
								{stepAccept["categorization.threat_model.read"] ?? currentOrgs?.categorizable ? (
									<Link to={url + "4.2"} className={cn(styles.active)}>
										4.2 Расчет экономического ущерба
									</Link>
								) : (
									<span className={styles.active} onClick={() => currentOrgs?.categorizable && needRules()}>
										4.2 Расчет экономического ущерба
									</span>
								)}
								<div className={styles.info}>
									<div className={styles.subTitle}>Расчетов подготовлено</div>
									<div className={styles.subText}>{dataSteps?.threat?.calculationsCount}</div>
								</div>
							</Step>

							<Step
								accept={stepAccept["categorization.step_5.read"] ?? currentOrgs?.categorizable}
								stepNumber={5}
								status={dataSteps?.categorization?.status}>
								{stepAccept["categorization.step_5.read"] ?? currentOrgs?.categorizable ? (
									<Link to={url + "5.1"} className={cn(styles.active)}>
										5.1 Категорирование ОКИИ
									</Link>
								) : (
									<span className={styles.active} onClick={() => currentOrgs?.categorizable && needRules()}>
										5.1 Категорирование ОКИИ
									</span>
								)}
								<div className={styles.info}>
									<div className={styles.subTitle}>Объектов получили категорию</div>
									<div className={styles.subText}>{dataSteps?.categorization?.objectsCount}</div>
								</div>
							</Step>

							<Step
								accept={stepAccept["categorization.step_6.read"] ?? currentOrgs?.categorizable}
								stepNumber={6}
								status={dataSteps?.document?.status}>
								{stepAccept["categorization.step_6.read"] ?? currentOrgs?.categorizable ? (
									<Link to={url + "6.1"} className={cn(styles.active)}>
										6.1 Подготовка и отправка результирующих документов
									</Link>
								) : (
									<span className={styles.active} onClick={() => currentOrgs?.categorizable && needRules()}>
										6.1 Подготовка и отправка результирующих документов
									</span>
								)}
								<div className={styles.info}>
									<div className={styles.subTitle}>Отправлено документов по ОКИИ</div>
									<div className={styles.subText}>{dataSteps?.document?.documentsCount}</div>
								</div>
							</Step>

							<Step
								accept={stepAccept["categorization.step_7.read"] ?? currentOrgs?.categorizable}
								stepNumber={7}
								status={dataSteps?.registration?.status}>
								{stepAccept["categorization.step_7.read"] ?? currentOrgs?.categorizable ? (
									<Link to={url + "7.1"} className={cn(styles.active)}>
										7.1 Присвоение ОКИИ реестровых номеров ФСТЭК и закрытие процесса
									</Link>
								) : (
									<span className={styles.active} onClick={() => currentOrgs?.categorizable && needRules()}>
										7.1 Присвоение ОКИИ реестровых номеров ФСТЭК и закрытие процесса
									</span>
								)}
								<div className={styles.info}>
									<div className={styles.subTitle}>ОКИИ получили реестровые номера</div>
									<div className={styles.subText}>{dataSteps?.registration?.objectsCount}</div>
								</div>
							</Step>
						</div>
					) : (
						<div className={styles.warningBox}>
							<div className={styles.warning}>
								Доступ к функциям категорирования для данной организации не предоставлен
							</div>
						</div>
					)}
				</div>
			)
		) : null;
	}
};

export default CategorizationPage;
